export default function ErrorPage(props) {
    return (
        <div className={'error-page'}>
            <div className={'oops'}>Oops!</div>
            <div className={'message'}>
                Something went wrong. Please try reloading the page...
            </div>
        </div>
    );
}
